module.exports = "/lucky-balls/img/bonus_green/header.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/lucky-balls/img/bonus_green/header.png
// module id = 940
// module chunks = 0